import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import { CREDIT_TYPE } from '../../../../framework/App/AppConstants';
import { TERMS_URL, US_NO_INTEREST_OFFER } from '../../../USConstants';
import TermsText from '../../TermsText/TermsText';

import './DefaultAsideContent.less';

const LOCALE_PREFIX = 'US/components/AsideContent/AsideContent';
const INSTALLMENT_TERMS_SUFFIX = 'installmentTerms';

export class DefaultAsideContent extends Component {

    static propTypes = {
        intl: intlShape.isRequired,
        creditType: PropTypes.string,
        imgElt: PropTypes.element,
        defaultMessage: PropTypes.string,
        financingDetails: PropTypes.shape({
            term: PropTypes.number,
            monthly_payment: PropTypes.string,
            total_interest: PropTypes.string,
            total_cost: PropTypes.string
        }),
        mppInstallmentsTermsUrl: PropTypes.string
    };

    static defaultProps = {
        defaultMessage: 'headline-core'
    };

    promoContent = (type, termsUrl) => {
        const { financingDetails, imgElt, intl, mppInstallmentsTermsUrl } = this.props;

        const creditType = _.toLower(type);
        const numMonths = _.get(financingDetails, 'term', US_NO_INTEREST_OFFER.TERM);
        const termsText = intl.formatHTMLMessage({ id: `${LOCALE_PREFIX}.terms-text-${creditType}`}, { numMonths });
        const termsLinkText = intl.formatMessage({ id: `${LOCALE_PREFIX}.terms-details-link-${creditType}` });

        return (
            <div className="aside-content aside-content--promo">
                {imgElt}
                <div className="aside-content-body">
                    <div className="aside-content-tagline">
                        <FormattedHTMLMessage
                            id={`${LOCALE_PREFIX}.tagline-${creditType}`}
                            tagName="div"
                            values={{ numMonths }}
                        />
                    </div>
                    <TermsText name={`${creditType}-terms`}
                        termsUrl={termsUrl}
                        termsText={termsText}
                        termsLinkText={termsLinkText}
                    />
                </div>
            </div>
        );
    }

    getContent(type) {
        const { financingDetails, imgElt, intl, mppInstallmentsTermsUrl, defaultMessage } = this.props;
        const installmentsTermsText = intl.formatMessage({ id: `${LOCALE_PREFIX}.terms-text-inst` });
        const installmentsTermsLinkText = intl.formatMessage({ id: `${LOCALE_PREFIX}.terms-details-link-inst` });
        switch (type) {
            case CREDIT_TYPE.INSTALLMENTS:
                return (
                    <div className="aside-content">
                        {imgElt && <div className="aside-content-icon">{imgElt}</div>}
                        <div className="aside-content-body">
                            <div className="aside-content-headline">
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.headline-inst`}
                                    values={{
                                        num: _.get(financingDetails, 'term')
                                    }}
                                />
                            </div>
                            <div className="aside-content-installment">
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.tagline-inst-line1`}
                                    values={{
                                        num: _.get(financingDetails, 'term'),
                                        monthPayment: _.get(financingDetails, 'monthly_payment')
                                    }}
                                /> <br />
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.tagline-inst-line2`}
                                    values={{
                                        percent: _.toNumber(_.get(financingDetails, 'apr')),
                                        totalInterest: _.get(financingDetails, 'total_interest')
                                    }}
                                /> <br />
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.tagline-inst-line3`}
                                    values={{
                                        totalPayment: _.get(financingDetails, 'total_cost')
                                    }}
                                />
                            </div>
                            <TermsText name="installment-terms"
                                termsUrl={(mppInstallmentsTermsUrl) ? mppInstallmentsTermsUrl : INSTALLMENT_TERMS_SUFFIX}
                                termsText={installmentsTermsText}
                                termsLinkText={installmentsTermsLinkText}
                            />
                        </div>
                    </div>
                );
            case CREDIT_TYPE.NO_INTEREST:
                return this.promoContent(type, TERMS_URL);
            default:
                return (
                    <div className="aside-content">
                        {imgElt}
                        <div className="aside-content-body">
                            <div className="aside-content-headline">
                                <FormattedHTMLMessage id={`${LOCALE_PREFIX}.${ defaultMessage }`} />
                            </div>
                        </div>
                    </div>
                );
        }
    }

    render() {
        const {creditType} = this.props;

        return (
            <div className="DefaultAsideContent">
                {this.getContent(creditType)}
            </div>
        );
    }
}

export default injectIntl(DefaultAsideContent);
